import { APP } from '_pixiSrc/globals';
import {
    easeInOut as defaultEase,
} from '_pixiSrc/animation/easing/smoothstep';
import AudioManager from './AudioManager';
import SwitchButton from './SwitchButton';
import GameData from './GameData';

const STATE_START = 0;
const STATE_STOP = 1;

/**
 * @class MobileSpinButton
 * @extends {SwitchButton}
 * @description A unique button with the behavior of a normal spin button for mobile
 */
class MobileSpinButton extends SwitchButton {
    /**
     * Creates an instance of MobileSpinButton.
     * @param {*} path asset name
     * @param {*} x
     * @param {*} y
     * @param {*} scale default scale
     * @param {*} clickAction call on click when button in STATE_STOP state
     * @param {*} [closeAction=() => {}] call on click when button in STATE_START state
     */
    constructor(path, x, y, scale, clickAction, closeAction = () => { /* empty */ }) {
        super(path, x, y, scale, clickAction, closeAction);

        // used to check whether is in landscape mode or not
        this.isLandscape = APP.layout.orientation === 'landscape';
    }

    /**
     * display sprite of button as its state
     * @override
     */
    updateState() {
        // emit statechange only when landscape mode found
        if (this.isLandscape) {
            this.emit('statechange');
        }
        if (this.state === STATE_START) { // 0
            // only for landscape
            if (this.isLandscape && GameData.getProperty('isTurboChecked')) {
                // display spin button container with fade in effect
                this.parent.fadeTo(1, 150, defaultEase);
                this.interactive = true;
                return;
            }
            if (this.isDisabled) {
                this.gotoAndStop(6);
            } else if (this.isPointerDown) {
                this.gotoAndStop(4);
            } else {
                this.gotoAndStop(0);
            }
        }
        if (this.state === STATE_STOP) { // 1
            // only for landscape
            if (this.isLandscape && GameData.getProperty('isTurboChecked')) {
                // hide spin button container with fade out effect
                this.parent.fadeTo(0, 150, defaultEase);
                this.interactive = false;
                return;
            }
            if (this.isPointerDown) {
                this.gotoAndStop(5);
                return;
            }
            this.gotoAndStop(1);
        }
    }

    /**
     * Only for mobile devices
     * initialize button with its user interactive events
     * override because on stop state spin button should not disabled
     * @override
     */
    _initMobile() {
        this.switchState(STATE_START);

        this.on('pointerdown', () => {
            this.isPointerDown = true;
            this.updateState();
            this.mobileClickHandler();
        });

        this.on('pointerup', () => {
            this.isPointerDown = false;
            this.updateState();
        });
        this.on('pointerupoutside', () => {
            this.isPointerDown = false;
            this.updateState();
        });
    }
}
export default MobileSpinButton;
